import { Controller } from "@hotwired/stimulus"

// Used by the order-edit / order-edit-license forms (which render into the
// layout's modal turbo-frame). On real success the server responds with a
// turbo_stream (HTTP 200); on validation error it returns 422 (head only).
// So `success` (= 2xx) is the right signal: close modal on success, leave
// the modal open with the form re-rendered on validation error.
//
// Replaces the inline turbo:submit-end handlers in orders/show.html.erb
// and orders/index.html.erb.
export default class extends Controller {
  static outlets = ["modal"]

  onSubmit(event) {
    if (!event.detail.success) return
    if (this.hasModalOutlet) this.modalOutlet.close()
    window.location.reload()
  }
}
